import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ICONS } from '../icons';

const useCreateProjectCards = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        title: 'Resonance',
        description: t('projectMediaAndTrackingTools', { projectType: 'Resonance' }),
        logo: ICONS.Resonance,
        path: 'resonance',
      },
      {
        title: 'Sonar',
        description: t('projectMediaAndTrackingTools', { projectType: 'Sonar' }),
        logo: ICONS.Sonar,
        path: 'sonar',
      },
      {
        title: 'Scout',
        description: t('projectMediaAndTrackingTools', { projectType: 'Scout' }),
        logo: ICONS.Scout,
        path: 'scout',
      },
      {
        title: 'Genie',
        description: t('projectMediaAndTrackingTools', { projectType: 'Genie' }),
        logo: ICONS.Genie,
        path: 'genie',
      },
      {
        title: 'GenieGo',
        description: t('projectMediaAndTrackingTools', { projectType: 'Genie' }),
        logo: ICONS.Genie,
        path: 'genie-go',
      },
      {
        title: 'ID8',
        description: t('projectMediaAndTrackingTools', { projectType: 'ID8' }),
        logo: ICONS.Scout,
        path: 'id8',
      },
      {
        title: 'ACTIV8',
        description: t('projectMediaAndTrackingTools', { projectType: 'ACTIV8' }),
        logo: ICONS.Activ8,
        path: 'activ8',
      },
      {
        title: 'Pulse',
        description: t('projectMediaAndTrackingTools', { projectType: 'Pulse' }),
        logo: ICONS.Pulse,
        path: 'pulse',
        disabled: true,
      },
    ],
    [t],
  );
};

export default useCreateProjectCards;
